export default "__VITE_ASSET__146P_XGe__";